import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { modalOpenMedical } from "../../../Redux/loadingReducer";

export default function ConfirmBox ({
  show: controlledShow,
  title,
  message,
  errors,
  showIcon = true,
  confirmText = "Confirm",
  cancelText = "Close",
  onConfirm,
  onClose,
  showConfirmButton = false,
}) {
  const { modalDetails } = useSelector((state) => state.loading);

  const dispatch = useDispatch();

  const isControlled = typeof controlledShow === "boolean";
  const show = isControlled ? controlledShow : modalDetails?.open;
  const modalTitle = isControlled ? title : modalDetails?.message;
  const modalErrors = isControlled ? errors : modalDetails?.errors;
  const modalMessage = isControlled ? message : "";
  const shouldShowIcon = isControlled ? showIcon : true;

  const handleCancel = () => {
    if (typeof onClose === "function") {
      onClose();
      return;
    }
    dispatch(modalOpenMedical(""));
  };

  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
      return;
    }
    dispatch(modalOpenMedical(""));
  };

  return (
    <>
      {show && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              {modalTitle && (
                <>
                  <div className="modal-header">
                    <h5 className="modal-title d-flex align-items-center gap-2">
                      {shouldShowIcon && (
                        <i className="bi bi-exclamation-circle-fill text-danger"></i>
                      )}
                      {modalTitle}
                    </h5>
                  </div>
                </>
              )}
              {(modalMessage || modalErrors) && (
                <div className="modal-body">
                  {modalMessage && <p className="m-1">{modalMessage}</p>}
                  {modalErrors?.map((err, i) => (
                    <p className="m-1" key={i}>{err}</p>
                  ))}
                </div>
              )}
              <div className="modal-footer">
                {showConfirmButton && (
                  <button
                    className="btn btn-primary"
                    onClick={handleConfirm}
                  >
                    {confirmText}
                  </button>
                )}
                <button
                  className="btn small-btn-primary"
                  onClick={handleCancel}
                >
                  {cancelText}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
